import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setJobPurchaseOrderInvoiceFile, setJobPurchaseOrderInvoiceNumber} from "../jobPurchaseOrderActions";
import {toFixedPrice} from "../../jobEditPopup/jobPricingFunctions";
import {getParsedJobOrder} from "../jobOrderFunctions";
import {PURCHASE_ORDER_CONTENT} from "../jobPurchaseOrderReducer";


const JobPurchaseOrderPay = (props) => {

  const {job, purchaseOrderStep, purchaseOrderErrorMessage} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  const isSuccessPage = purchaseOrderStep === PURCHASE_ORDER_CONTENT.purchaseOrderPaySuccess;

  return (
    <div className={"flex flex--column flex--center relative job-payment__content relative"}>
      <div className={"job-payment__status flex flex--center"
        + (isSuccessPage && !purchaseOrderErrorMessage ? "" : " job-payment__status--error")}>
        <FormattedMessage id={purchaseOrderErrorMessage ? "jobBoard.purchaseOrderPopup.payErrorLabel" : isSuccessPage
          ? "jobBoard.purchaseOrderPopup.paySuccessLabel"
          : "jobBoard.purchaseOrderPopup.sendPayment"}/>
      </div>
      <div className="job-payment__order-id">
        <span className="pr-15">PO ID: <span className="bold">{jobOrder.orderId}</span></span>
        <span>Invoice ID: <span className="bold">{jobOrder.invoiceId}</span></span>
      </div>
      {purchaseOrderErrorMessage ? (
        <div className="text-center mb-2">
          <p className={"job-payment__title color-red3"}>
            <FormattedMessage id={"paymentPopup.errorTitle"}/>
          </p>
          <p className={"job-payment__text job-payment__container margin-b16 margin-t0 text-center color-red3"}>
            <FormattedMessage id={"paymentPopup.errorText"}/>
          </p>
          <p className="font--16 job-payment__container color-red m-0">{purchaseOrderErrorMessage}</p>
        </div>
      ) : (
        <div className="text-center mb-2">
          <p className="font--16 job-payment__container color-charcoal m-0">
            <FormattedMessage id={isSuccessPage
              ? "jobBoard.purchaseOrderPopup.paySuccessText"
              : "jobBoard.purchaseOrderPopup.payText"}
                              values={{
                                invoiceId: jobOrder.invoiceId,
                                fabricatorName: jobOrder.childFabricatorName,
                                total: "$" + toFixedPrice(jobOrder.referralAmount),
                                span: (msg) => <span className="bold">{msg}</span>
                              }}/>
          </p>
          <p className="font--16 job-payment__container color-charcoal mt-1 mb-0">
            <FormattedMessage id={isSuccessPage
              ? "jobBoard.purchaseOrderPopup.paySuccessText2"
              : "jobBoard.purchaseOrderPopup.payText2"}/>
          </p>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {purchaseOrderStep, purchaseOrderErrorMessage} = store.jobPurchaseOrderPopupState;
  const {job} = store.jobEditPopupState;

  return {
    purchaseOrderStep,
    purchaseOrderErrorMessage,
    job,
  };
};

const mapDispatchToProps = {
  setJobPurchaseOrderInvoiceNumber,
  setJobPurchaseOrderInvoiceFile,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrderPay)
)
